import {DEFAULT_PAGE} from "../../contstants";
import getDateRange from "../../utils/getDateRange";
import {GetSellOrdersShiftReport} from "../sell-orders/getSellOrdersShiftReport";

const FilterShiftReports = async (perPage, filters) => {

    const page = filters.page || DEFAULT_PAGE;
    const type = '';
    const searchInFields = filters.search_in_fields || '';
    const searchPhrase = filters.s;
    const user = searchInFields.includes('user') ? searchPhrase : '';
    const id = searchInFields.includes('id') ? searchPhrase : '';
    const office_id = filters.office_id;
    const corporate_customer_id = filters.corporate_customer_id ?? "";

    const { dateFrom, dateTo } = getDateRange(filters.date);

    return await GetSellOrdersShiftReport({
        // The tax columns read the derived figures, which only the detailed
        // list returns. The export path (perPage -1) collects ids only.
        details: perPage !== -1,
        limit: perPage,
        offset: (page - 1) * perPage,
        type,
        office_id,
        dateFrom,
        dateTo,
        id,
        user,
        corporate_customer_id
    });
};

export default FilterShiftReports;
